
import { Options, Vue } from 'vue-class-component';
import { Course, CourseEnrollment } from "@/data/course";

@Options({
    props: {
        course: {
            type: Object,
            required: true,
        },
        classes: {
            type: String,
            required: false,
            default: '',
        }
    },
    components: {

    },
})
export default class CourseSpecialInfo extends Vue {
    course!: Course
    classes!: string

    // mounted() {}
}
